import React from 'react';
import { CheckIcon, ShieldCheckIcon, RefreshCwIcon, CreditCardIcon } from 'lucide-react';
export const TrustBadges = () => {
  return <section className="py-10 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-401">
      <div className="max-w-7xl mx-auto" data-id="element-402">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-403">
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-404">
            <div className="bg-teal-100 p-2 rounded-full mb-3" data-id="element-405">
              <CheckIcon className="h-5 w-5 text-teal-600" data-id="element-406" />
            </div>
            <p className="text-sm font-medium text-gray-800" data-id="element-407">
              Revisión profesional
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-408">
            <div className="bg-teal-100 p-2 rounded-full mb-3" data-id="element-409">
              <RefreshCwIcon className="h-5 w-5 text-teal-600" data-id="element-410" />
            </div>
            <p className="text-sm font-medium text-gray-800" data-id="element-411">
              Actualizaciones gratis
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-412">
            <div className="bg-teal-100 p-2 rounded-full mb-3" data-id="element-413">
              <ShieldCheckIcon className="h-5 w-5 text-teal-600" data-id="element-414" />
            </div>
            <p className="text-sm font-medium text-gray-800" data-id="element-415">Garantía 7 días</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-416">
            <div className="bg-teal-100 p-2 rounded-full mb-3" data-id="element-417">
              <CreditCardIcon className="h-5 w-5 text-teal-600" data-id="element-418" />
            </div>
            <p className="text-sm font-medium text-gray-800" data-id="element-419">
              Pago seguro y protegido
            </p>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-420">
          <p className="text-sm text-gray-600" data-id="element-421">
            +2,800 personas ya cocinan más rico y rápido con este recetario
          </p>
        </div>
      </div>
    </section>;
};